"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobProcessingStatus = void 0;
var JobProcessingStatus;
(function (JobProcessingStatus) {
    JobProcessingStatus["NotCreated"] = "NotCreated";
    JobProcessingStatus["New"] = "New";
    JobProcessingStatus["Active"] = "Active";
    JobProcessingStatus["NotStarted"] = "NotStarted";
    JobProcessingStatus["Processing"] = "Processing";
    JobProcessingStatus["Success"] = "Success";
    JobProcessingStatus["Error"] = "Error";
})(JobProcessingStatus = exports.JobProcessingStatus || (exports.JobProcessingStatus = {}));
//# sourceMappingURL=job-processing-status.js.map